export default __webpack_public_path__ + "static/media/06.e2cf781f.svg";